import React from 'react'
import UnderwriterDashboard from 'components/UnderwriterDashboard/UnderwriterDashboard'

const UnderwriterDashboardContainer = () => <UnderwriterDashboard />

export default UnderwriterDashboardContainer
